import type { CSSObject, Theme } from "@mui/material/styles";

import { CARD_BORDER_RADIUS, DRAWER_WIDTH_MD } from "@/constants/layout";

/**
 * The original's two shared layout mixins, recovered verbatim from the `_app`
 * bundle (module 42087, exports `f` and `W`). Everything that behaves like a
 * side panel or a centred modal in this app derives its responsive size from
 * one of these, which is why every overlay measures the same at a given width.
 *
 * Remember the breakpoints are redefined: `md` is 800 and `lg` is 900.
 */

/** Side-panel width: full-bleed under `lg`, 360px to `xxl`, then 30vw ≤ 500px. */
export const panelWidth = (theme: Theme): CSSObject => ({
  [theme.breakpoints.down("lg")]: {
    maxWidth: "100vw",
    width: "100vw",
    "& .MuiDrawer-paper": {
      maxWidth: "100vw",
      width: "100vw",
      boxSizing: "border-box",
    },
  },
  [theme.breakpoints.between("lg", "xxl")]: {
    maxWidth: DRAWER_WIDTH_MD,
    width: DRAWER_WIDTH_MD,
    "& .MuiDrawer-paper": {
      maxWidth: DRAWER_WIDTH_MD,
      width: DRAWER_WIDTH_MD,
      boxSizing: "border-box",
    },
  },
  [theme.breakpoints.up("xxl")]: {
    maxWidth: 500,
    width: "30vw",
    "& .MuiDrawer-paper": {
      maxWidth: 500,
      width: "30vw",
      boxSizing: "border-box",
    },
  },
});

/** Modal surfaces go full-width with 20px top corners under `md`. */
export const sheetOnMobile = (theme: Theme): CSSObject => ({
  [theme.breakpoints.down("md")]: {
    maxWidth: "100%",
    width: "100%",
    borderRadius: `${CARD_BORDER_RADIUS}px ${CARD_BORDER_RADIUS}px 0 0`,
  },
});
